import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import moment from 'moment'
import axios from 'axios'
import './assets/styles/custom.scss';
import VueSwal from 'vue-swal';
import VueCookies from 'vue-cookies'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'

Vue.use(VueCookies);
Vue.component('Multiselect', Multiselect)
Vue.use(VueSwal);

let baseUrl="https://staging.crm.property-pistol.in/api/reports";
let cookieDomain = ''
export const DEFAULT_SOURCCE_ID = '3'
if(process.env.NODE_ENV === 'production'){
  baseUrl = "https://staging.crm.property-pistol.in/api/reports"
  cookieDomain = 'property-pistol.in'
}
Vue.$cookies.config('30d', '/', cookieDomain, '', 'Lax');
axios.defaults.baseURL = baseUrl;
//axios interceptors
axios.interceptors.request.use(function(config) {
  store.dispatch('setLoading', true);
  if(config.url.indexOf('login') < 0){
    let token = Vue.$cookies.get('crm-token');
    config.headers.common['ngrok-skip-browser-warning'] = true;
    if(token){
      config.headers.Authorization = `Token token=${token}`
    }else{
      return {
        headers: {},
        method: config.method,
        url: ""
      };
    }
  }
  config.headers['Content-Type'] = 'application/json'
  config.headers['Accept'] = 'application/json'
  return config;
}, function(err) {
  store.dispatch('setLoading', false);
  return Promise.reject(err);
});

axios.interceptors.response.use(function(response) {
  store.dispatch('setLoading', false);
  return response;
}, function(error){
  if(error.response.status === 401){
    store.dispatch('setLoading', false);
    Vue.$cookies.remove('crm-token');
    Vue.$cookies.remove('crm-user-name');
    Vue.$cookies.remove('crm-user-email');
    swal({
      title: "Session Expired",
      text: "You have been redirected to the login page",
      icon: "error"
    })
    .then(router.replace('/login'));
  }else{
    store.dispatch('setLoading', false);
    return Promise.reject(error);
  }
});

router.beforeEach((to, from, next) => {
  let token = Vue.$cookies.get('crm-token')
  if(token && to.name === 'Login'){
    next({name: 'Source-Wise'});
  }else if(to.name !== 'Login' && !token){
    next({name: 'Login'});
  }else{
    if(to.name === 'Login'){
      store.dispatch('setLayout', 'login');
    }else if(['AllReports','Call-Activity','Backlog','UserRoi','ProjectRoi','SourceRoi', 'Qualification','SubSource-Wise','Source-Wise', 'User-Wise', 'Enquiry-Wise', 'MarketingActivation', 'More','LeadAgeingReports','MarketingCampaignReport'].includes(to.name)){
      store.dispatch('setLayout', 'home');
    }else{
      store.dispatch('setLayout', 'default');
    }
    next();
  }
})

Vue.config.productionTip = false
Vue.use(BootstrapVue);
Vue.prototype.$moment = moment;
Vue.prototype.$axios = axios;
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
